window.TCS_API_URL =
  "https://script.google.com/macros/s/AKfycby72mz_OsT4ZoNED1qIeea5sB4Q1QKY9F2mziNIgrmaiYNftTrwmyd5f9ApsYMdg6uR/exec";

window.TCSApi = {
  async get(action, params = {}) {
    const query = new URLSearchParams({
      action,
      ...params
    });

    const response = await fetch(window.TCS_API_URL + "?" + query.toString());
    return response.json();
  },

  async text(action, params = {}) {
    const query = new URLSearchParams({
      action,
      ...params
    });

    const response = await fetch(window.TCS_API_URL + "?" + query.toString());
    return response.text();
  }
};